import { Directive, Output, EventEmitter, Input, ElementRef } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Directive({
  selector: '[debounce]'
})
export class DebounceDirective {
  @Output('debounce') value = new EventEmitter<string>();
  @Input() delay: number = 500;
  constructor(private element: ElementRef<HTMLInputElement>) { }
  subscription: Subscription;
  ngOnInit() {
    const eventStream = fromEvent<string>(this.element.nativeElement, 'input')
      .pipe(debounceTime(this.delay), distinctUntilChanged());
    this.subscription = eventStream.subscribe(input => { this.value.emit(input); });
  }
  ngOnDestroy() { if (this.subscription) this.subscription.unsubscribe(); }
}
